import { Icon, IconProps } from '@chakra-ui/react'

export function PowerSupplyIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 18 35" {...props}>
      <path
        d="M16.5701 12.757H11.4054L15.2259 2.33599C15.4735 1.63423 14.9429 0.862305 14.2 0.862305H5.0381C4.50748 0.862305 4.04762 1.21318 3.9415 1.7395L0.368708 18.336C0.227212 19.0377 0.757824 19.6693 1.46531 19.6693H5.60408L1.85442 32.7921C1.50068 33.9851 3.12789 34.722 3.83538 33.7395L17.4898 14.5114C17.985 13.7746 17.4544 12.757 16.5701 12.757Z"
        fill="currentColor"
      />
    </Icon>
  )
}
